import { withRouter } from 'react-router-dom';

import Flow from './Flow';

export default withRouter(Flow);
